// Vendor Libs
import moment from 'moment-timezone';
import {forEach} from 'lodash';

const defaultDateFormat = 'MM/DD/YYYY';
const defaultDurationFormat = 'h m s';
const defaultDurationUnit = 'seconds';
const defaultParseFormats = [moment.ISO_8601, 'YYYY-MM-DD', 'x'];
const defaultTimezoneFormat = 'MM/DD/YYYY hh:mm:ss A z';
const durationSplitRegex = /[\s]*([\d]+)[\s]*([dhms])[\s]*/i;
const durationSplitGroupRegex = /[\s]*([\d]+[\s]*[dhms])[\s]*/i;

export function formatDate(dateString, format = defaultDateFormat, parseFormats = defaultParseFormats, invalidDate) {
  // parseDate() now returns a native Date or null
  const d = parseDate(dateString, parseFormats);
  if (!d) return invalidDate;

  // wrap it in moment() so .format() is available
  return moment(d).format(format);
}

export function formatTimezone(
    dateString,
    format = defaultTimezoneFormat,
    timezone,
    parseFormats = defaultParseFormats,
    invalidDate
) {
    // turn your input into a JS Date (or null)
    const date = parseDate(dateString, parseFormats);
    if (!date) return invalidDate;

    // choose the IANA zone
    const tzName = timezone || moment.tz.guess();

    // wrap in moment() so .tz() is available, then format
    return moment(date).tz(tzName).format(format);
}

export function formatDuration(
    durationString,
    format = defaultDurationFormat,
    durationUnit = defaultDurationUnit,
    invalidDuration
) {
    const results = [];
    const duration = moment.duration(Number(durationString), durationUnit);

    forEach(format.split(' '), (unit) => {
        const unitValue = duration.get(unit);

        if (unitValue) {
            results.push(`${unitValue}${unit}`);
        }
    });

    return results.length ? results.join(' ') : invalidDuration;
}

export function isValidDate(date, formats = defaultParseFormats) {
    // Use strict parsing
    return moment(date, formats, true).isValid();
}

export function isValidDuration(durationString) {
    return parseDuration(durationString) !== null;
}

export function parseDate(dateString, formats = defaultParseFormats) {
  if (!dateString) return null;
  // support string or array for formats
  const fmts = Array.isArray(formats) ? formats : [formats];
  const m = moment(dateString, fmts, true);
  return m.isValid() ? m.toDate() : null;
}

export function parseDuration(durationString = '') {
    let durationParts = {};

    if (durationString !== null) {
        forEach(durationString.split(durationSplitGroupRegex), (part) => {
            if (part !== '') {
                const match = durationSplitRegex.exec(part);

                if (match !== null && match.length > 2) {
                    const unit = match[2].toLowerCase();

                    if (durationParts[unit]) {
                        durationParts = {};
                        return false;
                    }

                    [, durationParts[unit]] = match;
                } else {
                    durationParts = {};
                    return false;
                }
            }
        });
    }

    const result = moment.duration(durationParts);

    return result.as(defaultDurationUnit) > 0 ? result : null;
}

export function parseDurationAs(durationString, unit = defaultDurationUnit) {
    const duration = parseDuration(durationString);

    return duration !== null ? duration.as(unit) : null;
}
